import PropTypes from 'prop-types';
import React from 'react';
import BasicTeaserShaped from '@components/molecules/basic-teaser-shaped/basicTeaserShaped';
import TeaserShaped from '@components/molecules/teaser-shaped/teaserShaped';
import track from '@helper/tracking';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import StyledTeaserContainerShaped from './teaserContainerShaped.style';

const TeaserContainerShaped = ({ data, ...props }) => {
  if (data.teaserContainerEntries.length === 0) return null;

  return (
    <StyledTeaserContainerShaped {...props} aria-label={data.teaserContainerHeadline || 'Teasers'}>
      <Container large id={data.id}>
        {data.teaserContainerHeadline && (
          <div className="teasers__headline">
            <Headline secondary>{data.teaserContainerHeadline}</Headline>
          </div>
        )}
        <div className="teasers__grid">
          {data.teaserContainerEntries.length > 0 &&
            data.teaserContainerEntries.map((teaser, index) => {
              if (!teaser.title && !teaser.headline) {
                return null;
              }
              if (index === 0) {
                return (
                  <div key={teaser.id} className="teasers__grid-item highlight-teaser">
                    <TeaserShaped
                      onClick={() => {
                        track(['trackEvent', 'HighlightTeaser', 'Click', teaser.headline]);
                      }}
                      {...teaser}
                    />
                  </div>
                );
              }
              return <BasicTeaserShaped key={teaser.id} {...teaser} />;
            })}
        </div>
      </Container>
    </StyledTeaserContainerShaped>
  );
};

TeaserContainerShaped.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default TeaserContainerShaped;
